import _ from 'lodash'
import { ProductLine } from '@adc/ui-core'
import {
  generalRoutes,
  loggedInRoutes,
  buyRoutes,
  learnRoutes,
  newBuyRoutes,
  AUCTION_RESIDENTIAL,
  buyGeneral,
  aboutUs,
  getSellLinkData,
  getSmartSaleBuyLinkData,
} from './routes.js'

export const moreDropdown = [
  { ...generalRoutes.calendar, elmId: `more_${generalRoutes.calendar.elmId}` },
  { ...generalRoutes.help, elmId: `more_${generalRoutes.help.elmId}` },
]

export const helpDropdown = [generalRoutes.helpCenter]

export const buyDropdown = Object.values(buyRoutes)

const featureFlaggedRoutes = {
  privateSeller: 'fe.resi.search.private-seller-enabled',
}

const featureFlaggedRouteNames = new Set(Object.keys(featureFlaggedRoutes))

export const getNewBuyDropdown = featureFlags => {
  const enabledBuyRoutes = _.pickBy(newBuyRoutes, (value, key) => {
    const isFeatureFlagged = featureFlaggedRouteNames.has(key)
    if (!isFeatureFlagged) {
      return true
    }

    return featureFlags[featureFlaggedRoutes[key]]
  })

  return Object.values(enabledBuyRoutes)
}

export const getLearnDropdown = (
  featureFlags,
  isDealsForYouLinkShown = false
) => {
  const base = Object.values(learnRoutes)
  // When the Deals For You link is shown, About Us moves into the Learn
  // dropdown. When it isn't (flag off, stale, not loaded, or no recs) About Us
  // renders as a standalone top-level link — the pre-feature (flag-off) treatment.
  if (isDealsForYouLinkShown) {
    base.push(aboutUs)
  }
  return base
}

export const loggedInDropdown = (addOffers, featureFlags) => {
  const baseRoutes = [loggedInRoutes.userPreferences]
  const featureFlaggedRoutes = [
    ...(!featureFlags['fe.resi.is-buyer-dashboard-menu-item-enabled']
      ? [
          loggedInRoutes.savedAssets,
          loggedInRoutes.bidding,
          loggedInRoutes.purchaseProfiles,
          loggedInRoutes.postAuction,
        ]
      : []),
    ...(addOffers &&
    !featureFlags['fe.resi.is-buyer-dashboard-menu-item-enabled']
      ? [loggedInRoutes.offers]
      : []),

    ...(featureFlags['fe.resi.is-buyer-dashboard-menu-item-enabled']
      ? [loggedInRoutes.buyersDashboard]
      : []),

    ...(featureFlags['fe.resi.enable-private-seller-dashboard-dropdown-menu']
      ? [loggedInRoutes.sellerDashboard]
      : []),
    loggedInRoutes.accountInfo,
    ...(featureFlags['fe.resi.enable-wallet'] ? [loggedInRoutes.wallet] : []),
  ]
  return [...baseRoutes, ...featureFlaggedRoutes]
}

export const mobileLoggedInDropdown = (addOffers, featureFlags) => {
  const baseRoutes = [
    { ...loggedInRoutes.userPreferences, elmId: 'mh_user_preferences' },
  ]
  const featureFlaggedRoutes = [
    ...(!featureFlags['fe.resi.is-buyer-dashboard-menu-item-enabled']
      ? [
          { ...loggedInRoutes.savedAssets, elmId: 'mh_saved_assets' },
          { ...loggedInRoutes.bidding, elmId: 'mh_bidding' },
          { ...loggedInRoutes.purchaseProfiles, elmId: 'mh_purchase_profiles' },
          { ...loggedInRoutes.postAuction, elmId: 'mh_post_auction' },
        ]
      : []),

    ...(addOffers &&
    !featureFlags['fe.resi.is-buyer-dashboard-menu-item-enabled']
      ? [{ ...loggedInRoutes.offers, elmId: 'mh_offers' }]
      : []),
    ...(featureFlags['fe.resi.is-buyer-dashboard-menu-item-enabled']
      ? [{ ...loggedInRoutes.buyersDashboard, elmId: 'mh_buyer_dash_assets' }]
      : []),
    ...(featureFlags['fe.resi.enable-private-seller-dashboard-dropdown-menu']
      ? [{ ...loggedInRoutes.sellerDashboard, elmId: 'mh_seller_dash' }]
      : []),
    { ...loggedInRoutes.accountInfo, elmId: 'mh_profile' },
    ...(featureFlags['fe.resi.enable-wallet']
      ? [{ ...loggedInRoutes.wallet, elmId: 'mh_wallet' }]
      : []),
  ]

  return [...baseRoutes, ...featureFlaggedRoutes]
}

export const smartSaleMobileLoggedInDropdown = (addOffers, featureFlags) => {
  return [loggedInRoutes.myListings, loggedInRoutes.accountInfo]
}

export const allDropdown = [
  { ...buyGeneral, elmId: `mh_${AUCTION_RESIDENTIAL}` },
  { ...generalRoutes.calendar, elmId: 'mh_calendar' },
  { ...generalRoutes.help, elmId: 'mh_help_center' },
]

export const getNewAllDropdown = (featureFlags, theme) => {
  const auctioncomLinks = [
    { ...buyGeneral, elmId: `mh_${AUCTION_RESIDENTIAL}` },
    getSellLinkData(theme, featureFlags),
    {
      ...generalRoutes.helpCenter,
      title: 'Learn',
      elmId: 'mh_learn',
    },
    {
      ...learnRoutes.blog,
      title: 'Blog',
      elmId: 'mh_blog',
    },
    { ...aboutUs, elmId: 'mh_about' },
  ]

  const smartSaleLinks = [
    getSmartSaleBuyLinkData(),
    getSellLinkData(theme, featureFlags),
  ]

  return theme.productLine === ProductLine.SmartSale
    ? smartSaleLinks
    : auctioncomLinks
}
